import React from 'react';
import SubscriptionForm from '../components/SubscriptionForm';
import './SubscriptionsPage.css';

export default function SubscriptionsPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Subscription</h1>
        <p>Manage your email subscription preferences for Vedanta Center updates.</p>
      </div>
      <SubscriptionForm />
    </div>
  );
}
